import React from "react";
import { useReportDateAccess } from "../hooks/useReportDateAccess";

const periodOnlyReports = new Set([
  "/reports/month-wise-items",
  "/monthly-summary",
  "/party-bills",
]);

export default function ReportDateAccessBoundary({ path, children }) {
  const { todayOnly, today } = useReportDateAccess();
  const normalizedPath = String(path || "").toLowerCase().replace(/\/+$/, "");
  const isReport = normalizedPath.startsWith("/reports/") ||
    ["/sales", "/sales-report", "/sales-reports", "/monthly-summary", "/party-bills",
      "/finance/report", "/finance/profit-loss", "/finance/day-book"].includes(normalizedPath);
  if (!isReport) return children;
  if (todayOnly && periodOnlyReports.has(normalizedPath)) {
    return <main style={{ padding: 24 }}>
      <h1>Full date filter required</h1>
      <p>Your role can view today’s reports only. This report contains monthly or yearly data.</p>
      <p>The owner can enable Full date filter in Role Permissions.</p>
    </main>;
  }
  // Drop previous results and in-flight component state after a permission/date change.
  return <React.Fragment key={todayOnly ? `today:${today}` : "full"}>{children}</React.Fragment>;
}
